import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { fetchChatCardData, getChatRoomId } from "../firebase/chat";
import { ChatCardData } from "../interfaces/Message";
import User from "../interfaces/User";
import {
  setSelectedChatId,
  setSelectedReceiverData,
} from "../redux/messagingSlice";

const useSendMessage = () => {
  const [loading, setIsLoading] = useState<boolean>(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const handleSendMessage = async (
    firstUserId?: string,
    secondUserId?: string
  ) => {
    console.error("firstUserId", firstUserId, "secondUserId", secondUserId);
    if (firstUserId && secondUserId) {
      setIsLoading(true);
      const chatRoomId: string = await getChatRoomId(firstUserId, secondUserId);
      const receiverData: ChatCardData = await fetchChatCardData(
        chatRoomId,
        firstUserId
      );
      dispatch(setSelectedReceiverData(receiverData));
      dispatch(setSelectedChatId(chatRoomId));
      setIsLoading(false);
      router.push("/message");
    }
  };
  return { loading, handleSendMessage };
};

export default useSendMessage;
